// IE 2026 09 26 / ODOO-5800 (замер ie-dm7 gantt_payload, Bio, вся витрина: Гант движений 13,8 с, из них ~9 с — СКРЫТЫЕ вкладки того же списка: выключенный
// чарт строил серии по всем строкам 5,6 с, скрытая таблица заказывала словари ссылочных колонок 3,8 с; без них — 4,9 с): ЛЕНИВЫЕ СКРЫТЫЕ ВКЛАДКИ.
//
// Что было. Панель вкладок (AttrTabPanel, R13 lazyTabs) монтирует видимую вкладку сразу, а ВСЕ остальные — фоном (через 1,2 с порциями в простое потока):
// экшены бэка, адресующие контент неоткрытой вкладки, должны его находить. Фоном монтировались и ВЫКЛЮЧЕННЫЕ вкладки (use: false — у списка по умолчанию
// Chart, Bubble, Map, Gantt, Compare …: их не видно и открыть нельзя), а смонтированный компонент сразу строил данные: AttrChart — серии по всем строкам
// (initializeChart → content_Changed → load_data), AttrGanttMoves — модель (computed model при рендере). Грид в скрытой вкладке при каждом приходе данных
// заказывал словари / названия ссылочных колонок заранее (tabDictPrefetch → prefetch_hiddenDicts: обход всех строк).
//
// Что стало.
//   fe.ux.tabsLazyHidden (по умолчанию ВКЛ):
//     - фоновое домонтирование пропускает ВЫКЛЮЧЕННЫЕ вкладки (AttrTabPanel.tabDisabled); вкладку включили и открыли — она монтируется при активации,
//       как любая неоткрытая (selectedIndexChanged → openedTabs);
//     - AttrChart и AttrGanttMoves в СКРЫТОЙ (не выбранной) вкладке не строят серии / модель до первого показа: компонент смонтирован (экшены бэка его
//       находят), данные строятся при активации вкладки (handleVisibility) из уже пришедших строк — без запроса к бэку; показанный однажды — дальше как раньше.
//   fe.ux.gridDictPrefetchVisibleOnly (по умолчанию ВКЛ): грид в СКРЫТОЙ вкладке словари заранее не заказывает — они придут обычным путём при первом
//     показе (set_itemsSource / resolve_titlesByIds_); грид видимой вкладки заказывает, как раньше.
//   «Скрытая вкладка» — компонент лежит в невыбранной вкладке своей или любой объемлющей панели (inHiddenTab: цепочка Vue-родителей до AttrTabPanel,
//   сверка с tabPanel.selectedIndex). Панель ещё не инициализирована (первый кадр виджета) — неизвестно (null): решение откладывается или остаётся прежним.
//
// Выключатели (тот же реестр feSettings, что остальные fe.*): window.feSettings.set('fe.ux.tabsLazyHidden', false) / ('fe.ux.gridDictPrefetchVisibleOnly', false)
// или ?fe.ux.tabsLazyHidden=false в URL; консоль: window.tabsLazy.get() / .set('tabsLazyHidden', false) / .reset() / .stats() / .clear().
// Замеры (stats): сколько выключенных вкладок не смонтировано фоном, сколько сборок чарта / Ганта отложено и во что обошлась сборка при показе,
// сколько мс ушло на сборки в скрытой вкладке (при выключенном флаге) и на префетч словарей скрытых / видимых гридов.
import { toRaw } from 'vue'

export const FLAG_TABS = 'fe.ux.tabsLazyHidden'
export const FLAG_DICT = 'fe.ux.gridDictPrefetchVisibleOnly'
const FLAGS = { tabsLazyHidden: FLAG_TABS, gridDictPrefetchVisibleOnly: FLAG_DICT }

const stats = {
    tabsSkipped: 0,          // выключенные вкладки, которые фоновое домонтирование пропустило
    tabsMountedOnShow: 0,    // из них смонтированы позже — при активации
    chartHeld: 0,            // сборок чарта в скрытой вкладке не сделано (флаг ВКЛ)
    chartBuiltOnShow: 0, chartBuiltOnShowMs: 0,     // отложенная сборка при первом показе
    chartBuiltHidden: 0, chartBuiltHiddenMs: 0,     // сборки в скрытой вкладке (флаг ВЫКЛ или уже показанный чарт)
    ganttHeld: 0, ganttReleased: 0,                 // Гант движений: модель не строилась в скрытой вкладке / построена при показе
    dictSkipped: 0,                                 // префетч словарей скрытого грида пропущен (флаг ВКЛ)
    dictHidden: 0, dictHiddenMs: 0,                 // префетч словарей в скрытой вкладке (флаг ВЫКЛ)
    dictVisible: 0, dictVisibleMs: 0,               // префетч словарей грида видимой / неизвестной вкладки (как раньше)
}
const round = (x) => Math.round(x * 10) / 10

export function tabsLazy_on(store) {
    try { return !(store && typeof store.setting === 'function' && store.setting(FLAG_TABS, true) === false) } catch (e) { return true }
}
export function dictVisibleOnly_on(store) {
    try { return !(store && typeof store.setting === 'function' && store.setting(FLAG_DICT, true) === false) } catch (e) { return true }
}

// true — компонент лежит в НЕвыбранной вкладке панели (своей или любой объемлющей); false — во всех панелях цепочки его вкладка выбрана (или панелей нет);
// null — одна из панелей цепочки ещё не инициализирована (первый кадр виджета: выбранная вкладка станет известна после её initialized).
// Вкладка панели узнаётся по компоненту-вкладке в цепочке родителей: его attr_id или сам объект вкладки (attr) — как их раздаёт AttrTabPanel.tabAttrs
export function inHiddenTab(vm) {
    try {
        const ids = new Set(), objs = new Set()
        let unknown = false
        for (let c = vm, guard = 0; c && guard < 200; c = c.$parent, guard++) {
            if (c !== vm && c.openedTabs && typeof c.tabRendered === 'function' && Array.isArray(c.tabAttrs)) {   // AttrTabPanel
                const tp = c.tabPanel
                if (!tp) unknown = true
                else {
                    const idx = c.tabAttrs.findIndex(t => t && ((t.id != null && ids.has(t.id)) || objs.has(toRaw(t))))
                    if (idx >= 0 && tp.selectedIndex !== idx) return true
                }
            }
            const id = c.attr_id
            if (id != null) ids.add(id)
            const a = c.attr
            if (a && typeof a === 'object') objs.add(toRaw(a))
        }
        return unknown ? null : false
    } catch (e) { return false }
}

export function tabsLazy_count(key, ms) {
    if (!(key in stats)) return
    stats[key]++
    if (ms != null && (key + 'Ms') in stats) stats[key + 'Ms'] = round(stats[key + 'Ms'] + ms)
}

export function tabsLazy_console(store) {
    if (typeof window === 'undefined') return
    const flags = () => Object.fromEntries(Object.entries(FLAGS).map(([k, key]) => [k, store.setting(key, true) !== false]))
    window.tabsLazy = {
        flags: FLAGS,
        get: () => ({ ...flags(), stats: { ...stats } }),
        set(name, value) {
            const key = FLAGS[name] || name
            if (!Object.values(FLAGS).includes(key)) return { error: `tabsLazy: no option '${name}'`, options: Object.keys(FLAGS) }
            window.feSettings?.set?.(key, value)
            return this.get()
        },
        reset() { for (const key of Object.values(FLAGS)) window.feSettings?.unset?.(key); return this.get() },
        stats: () => ({ ...stats }),
        clear() { for (const k of Object.keys(stats)) stats[k] = 0; return { ...stats } },
        help: () => 'tabsLazy.set("tabsLazyHidden" | "gridDictPrefetchVisibleOnly", false) — прежнее поведение (перезагрузить виджет); .reset() — снять override; .stats() / .clear() — счётчики',
    }
}
